import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import LanguageDetector from 'i18next-browser-languagedetector';
import resourcesToBackend from 'i18next-resources-to-backend';
// import { isProduction } from '../../services/env';

i18n
  .use(
    resourcesToBackend((language, namespace) => import(`./locales/${language}/${namespace}.json`)),
  )
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    //  debug: !isProduction,
  });

export default i18n;
